import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import JoinTeamModalStore from './store';
import styles from './index.less';

const JoinTeamModal = ({ onClose, store }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  const isSuccess = store.mode === 'success';

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.root} data-name="弹窗-加入队伍">
        <div className={styles.layer1} data-name="弹窗背景" />

        <div className={styles.group2} data-name="状态3 - 已有队伍" aria-hidden={true}>
          <div className={styles.layer2} data-name="按钮-我知道了" />
          <div className={styles.layer3} data-name="您已有队伍，请勿重复加入">
            您已有队伍，请勿重复加入
          </div>
          <div className={styles.layer4} data-name="弹窗标题 - 提示 拷贝" />
        </div>

        <div
          className={cx(styles.group3, isSuccess && styles.activeState)}
          data-name="状态2 - 入队成功"
          role="dialog"
          aria-modal="true"
          aria-hidden={!isSuccess}
        >
          <button
            className={cx(styles.layer5, styles.hitArea)}
            data-name="按钮-立即前往主页"
            data-role="join-team-go-home"
            type="button"
            disabled={store.pending}
            onClick={store.goHome}
          />
          <div
            className={styles.layer6}
            data-name="恭喜您入队成功！请前往活动主页 回顾剑侠生涯并领取200元福利"
            data-text={'恭喜您入队成功！请前往活动主页\n回顾剑侠生涯并领取200元福利'}
          >
            恭喜您入队成功！请前往活动主页<br />回顾剑侠生涯并领取200元福利
          </div>
          <div className={styles.layer7} data-name="弹窗标题 - 恭喜您" />
        </div>

        <div
          className={cx(styles.group4, !isSuccess && styles.activeState)}
          data-name="状态1 - 确认入队"
          role="dialog"
          aria-modal="true"
          aria-hidden={isSuccess}
        >
          <button
            className={cx(styles.layer8, styles.hitArea)}
            data-name="按钮-确认加入"
            data-role="join-team-confirm"
            type="button"
            disabled={store.pending || store.confirmDisabled}
            onClick={store.handleConfirm}
          />
          <div className={styles.layer9} data-name="请您确认是否加入 少侠「XXXXXXXXX」的江湖同行队？ 确认加入后不可换队或退出。">
            请您确认是否加入<br />少侠「{store.inviterDisplayName}」的江湖同行队？<br />确认加入后不可换队或退出。
          </div>
          <div className={styles.layer10} data-name="弹窗标题 - 提示" />
        </div>

        <button
          className={cx(styles.layer11, styles.hitArea)}
          data-name="关闭弹窗按钮"
          data-role="join-team-close"
          type="button"
          disabled={store.pending}
          onClick={isSuccess ? store.closeSuccess : () => store.requestClose(onClose)}
        />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(JoinTeamModal, JoinTeamModalStore);
